import { create } from "zustand";

interface PercentageState {
  percentage: number;
  setPercentage: (value: number) => void;
}

const usePercentageStore = create<PercentageState>((set) => ({
  percentage: 0,
  setPercentage: (value) => set({ percentage: value }),
}));

export default usePercentageStore;
